import * as actions from './actions';

export default {
  strict: true,
  actions,
  state: {
    isFetchingBundles: true,
    isFetchingBundle: false,
    allowWebsocketUpdates: true,
    allBundles: [],
  },
  mutations: {
    'bundles/set': (state, { path, value }) => {
      state[path] = value;
    },
    storeAllBundles: (state, { bundles }) => {
      state.allBundles = bundles;
    },
  },
  getters: {
    getAllBundles: (state) => {
      return state.allBundles;
    },
  },
};
